import { FC } from 'react';
import {
  Control,
  FormState,
  UseFormGetValues,
  UseFormRegister,
} from 'react-hook-form';

import type { Condition } from 'types/notification';
import { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';
import {
  useCustomerStore,
  useRegistrationStore,
} from 'page/NotificationPage/hooks';
import { InputModalView } from './InputModalView';

type Props = {
  control: Control<NotificationFormFields>;
  formState: FormState<NotificationFormFields>;
  register: UseFormRegister<NotificationFormFields>;
  getValues: UseFormGetValues<NotificationFormFields>;
  handleClose: () => void;
  handleClickGoSecond: () => void;
};

export const InputModal: FC<Props> = ({
  control,
  formState,
  register,
  getValues,
  handleClose,
  handleClickGoSecond,
}) => {
  const { isOpenFirstModal, shouldShowCustomerList, setCondition } =
    useRegistrationStore();

  const { selectedCustomersLength } = useCustomerStore();

  /**
   * 配信対象顧客のラジオが変わったときの処理
   */
  const handleChangeCondition = (_condition: Condition) => {
    setCondition(_condition);
  };

  /** 確認ボタンの非活性状態 */
  const isButtonDisabled =
    !formState.isValid ||
    (shouldShowCustomerList && selectedCustomersLength === 0);

  return (
    <>
      {/* 入力モーダル */}
      <InputModalView
        control={control}
        formState={formState}
        isOpen={isOpenFirstModal}
        shouldShowCostomerList={shouldShowCustomerList}
        isButtonDisabled={isButtonDisabled}
        register={register}
        getValues={getValues}
        handleClose={handleClose}
        handleChangeCondition={handleChangeCondition}
        handleClickGoSecond={handleClickGoSecond}
      />
    </>
  );
};
